<template>
<div>

  <header class="main-header">
    <!-- Logo -->
    <a xhref="" class="logo">
      <!-- mini logo for sidebar mini 50x50 pixels -->
      <!-- <span class="logo-mini"><b>LT</b></span> -->
      <img src="images/Reloj_LaborTIME.png" class="logo-mini" style="width: 46px; margin-top: 2px; margin-left: -13px;" />

      <!-- logo for regular state and mobile devices -->
      <!-- <span class="logo-lg">LaborTIME</span> -->
      <img src="images/Logo_LaborTIME_Blanco.png" class="logo-lg" style="width: 105px; margin-top: 2px;" />
    </a>
    <!-- Header Navbar: style can be found in header.less -->
    <nav class="navbar navbar-static-top">
      <!-- Sidebar toggle button-->
      <a href="#" class="sidebar-toggle" data-toggle="offcanvas" role="button">
        <span class="sr-only">Toggle navigation</span>
      </a>

      <h1 class="navbar-title">
        - {{ title }} -
        <!--<small>Control panel</small>-->
      </h1>

      <div class="navbar-custom-menu">

        <div v-if="this.$auth.config.logo" style="display: inline-block; background-color: #fcfcfc; padding: 10px; height: 50px;">
          <img :src="this.$auth.config.logo" :style="this.$auth.config.logo_style || 'width: 120px;'" />
        </div>

        <!-- <div v-if="this.$auth.user.profile.domain !== undefined && this.$auth.user.profile.domain === 'thomas2'" style="display: inline-block; background-color: #fcfcfc; padding: 10px; height: 50px;">
          <img src="images/Logo_Thomas.png" style="width: 120px;" />
        </div>
        <div v-if="this.$auth.user.profile.domain !== undefined && this.$auth.user.profile.domain === 'express'" style="display: inline-block; background-color: #fcfcfc; padding: 10px; height: 50px;">
          <img src="images/Logo_Express.png" style="width: 120px;" />
        </div>
        <div v-if="this.$auth.user.profile.domain !== undefined && this.$auth.user.profile.domain === 'unicentro'" style="display: inline-block; background-color: #fcfcfc; padding: 10px; height: 50px;">
          <img src="images/Logo_Unicentro.jpg" style="width: 40px;" />
        </div>
        <div v-if="this.$auth.user.profile.domain !== undefined && this.$auth.user.profile.domain === 'miniso'" style="display: inline-block; background-color: #fcfcfc; padding: 10px; height: 50px;">
          <img src="images/Logo_Miniso.png" style="width: 25px;" />
        </div>
        <div v-if="this.$auth.user.profile.domain !== undefined && this.$auth.user.profile.domain === 'aero'" style="display: inline-block; background-color: #fcfcfc; padding: 10px; height: 50px;">
          <img src="images/Logo_Aero.png" style="width: 120px;" />
        </div>
        <div v-if="this.$auth.user.profile.domain !== undefined && this.$auth.user.profile.domain === 'trigus'" style="display: inline-block; background-color: #fcfcfc; padding: 10px; height: 50px;">
          <img src="images/Logo_Trigus.png" style="width: 40px;" />
        </div>
        <div v-if="this.$auth.user.profile.domain !== undefined && this.$auth.user.profile.domain === 'pippo'" style="display: inline-block; background-color: #fcfcfc; padding: 10px; height: 50px;">
          <img src="images/Logo_Pippo.png" style="width: 40px;" />
        </div>
        <div v-if="this.$auth.user.profile.domain !== undefined && this.$auth.user.profile.domain === 'conalpan'" style="display: inline-block; background-color: #fcfcfc; padding: 10px; height: 50px;">
          <img src="images/Logo_Conalpan.png" style="width: 55px;" />
        </div>
        <div v-if="this.$auth.user.profile.domain !== undefined && this.$auth.user.profile.domain === 'riogrande'" style="display: inline-block; background-color: #fcfcfc; padding: 10px; height: 50px;">
          <img src="images/Logo_Riogrande.png" style="width: 100px;" />
        </div>
        <div v-if="this.$auth.user.profile.domain !== undefined && this.$auth.user.profile.domain === 'aposentos'" style="display: inline-block; background-color: #fcfcfc; padding: 10px; height: 50px;">
          <img src="images/Logo_Aposentos.png" style="width: 120px;" />
        </div>
        <div v-if="this.$auth.user.profile.domain !== undefined && this.$auth.user.profile.domain === 'ancla'" style="display: inline-block; background-color: #fcfcfc; padding: 10px; height: 50px;">
          <img src="images/Logo_Ancla.png" style="width: 55px;" />
        </div>
        <div v-if="this.$auth.user.profile.domain !== undefined && this.$auth.user.profile.domain === 'multiflora'" style="display: inline-block; background-color: #fcfcfc; padding: 10px; height: 50px;">
          <img src="images/Logo_Multiflora.jpg" style="width: 120px;" />
        </div>
        <div v-if="this.$auth.user.profile.domain !== undefined && this.$auth.user.profile.domain === 'turia'" style="display: inline-block; padding: 10px; height: 50px;">
          <img src="images/Logo_Turia.png" style="width: 120px;" />
        </div> -->
        <ul class="nav navbar-nav">
          <!-- Messages: style can be found in dropdown.less-->
          <li class="dropdown messages-menu" v-if="false">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <i class="fa fa-envelope-o"></i>
              <span class="label label-success">4</span>
            </a>
            <ul class="dropdown-menu">
              <li class="header">You have 4 messages</li>
              <li>
                <!-- inner menu: contains the actual data -->
                <ul class="menu">
                  <li><!-- start message -->
                    <a href="#">
                      <div class="pull-left">
                        <!-- <img src="AdminLTE/dist/img/user2-160x160.jpg" class="img-circle" alt="User Image"> -->
                        <img src="images/person-icon.png" class="img-circle" alt="Usuario">
                      </div>
                      <h4>
                        Support Team
                        <small><i class="fa fa-clock-o"></i> 5 mins</small>
                      </h4>
                      <p>Why not buy a new awesome theme?</p>
                    </a>
                  </li>
                  <!-- end message -->
                  <li>
                    <a href="#">
                      <div class="pull-left">
                        <img src="AdminLTE/dist/img/user3-128x128.jpg" class="img-circle" alt="User Image">
                      </div>
                      <h4>
                        AdminLTE Design Team
                        <small><i class="fa fa-clock-o"></i> 2 hours</small>
                      </h4>
                      <p>Why not buy a new awesome theme?</p>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <div class="pull-left">
                        <img src="AdminLTE/dist/img/user4-128x128.jpg" class="img-circle" alt="User Image">
                      </div>
                      <h4>
                        Developers
                        <small><i class="fa fa-clock-o"></i> Today</small>
                      </h4>
                      <p>Why not buy a new awesome theme?</p>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <div class="pull-left">
                        <img src="AdminLTE/dist/img/user3-128x128.jpg" class="img-circle" alt="User Image">
                      </div>
                      <h4>
                        Sales Department
                        <small><i class="fa fa-clock-o"></i> Yesterday</small>
                      </h4>
                      <p>Why not buy a new awesome theme?</p>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <div class="pull-left">
                        <img src="AdminLTE/dist/img/user4-128x128.jpg" class="img-circle" alt="User Image">
                      </div>
                      <h4>
                        Reviewers
                        <small><i class="fa fa-clock-o"></i> 2 days</small>
                      </h4>
                      <p>Why not buy a new awesome theme?</p>
                    </a>
                  </li>
                </ul>
              </li>
              <li class="footer"><a href="#">See All Messages</a></li>
            </ul>
          </li>
          <!-- Notifications: style can be found in dropdown.less -->
          <li class="dropdown notifications-menu" v-if="false">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <i class="fa fa-bell-o"></i>
              <span class="label label-warning">10</span>
            </a>
            <ul class="dropdown-menu">
              <li class="header">You have 10 notifications</li>
              <li>
                <!-- inner menu: contains the actual data -->
                <ul class="menu">
                  <li>
                    <a href="#">
                      <i class="fa fa-users text-aqua"></i> 5 new members joined today
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fa fa-warning text-yellow"></i> Very long description here that may not fit into the
                      page and may cause design problems
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fa fa-users text-red"></i> 5 new members joined
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fa fa-shopping-cart text-green"></i> 25 sales made
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fa fa-user text-red"></i> You changed your username
                    </a>
                  </li>
                </ul>
              </li>
              <li class="footer"><a href="#">View all</a></li>
            </ul>
          </li>
          <!-- Tasks: style can be found in dropdown.less -->
          <li class="dropdown tasks-menu" v-if="false">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <i class="fa fa-flag-o"></i>
              <span class="label label-danger">9</span>
            </a>
            <ul class="dropdown-menu">
              <li class="header">You have 9 tasks</li>
              <li>
                <!-- inner menu: contains the actual data -->
                <ul class="menu">
                  <li><!-- Task item -->
                    <a href="#">
                      <h3>
                        Design some buttons
                        <small class="pull-right">20%</small>
                      </h3>
                      <div class="progress xs">
                        <div class="progress-bar progress-bar-aqua" style="width: 20%" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">
                          <span class="sr-only">20% Complete</span>
                        </div>
                      </div>
                    </a>
                  </li>
                  <!-- end task item -->
                  <li><!-- Task item -->
                    <a href="#">
                      <h3>
                        Create a nice theme
                        <small class="pull-right">40%</small>
                      </h3>
                      <div class="progress xs">
                        <div class="progress-bar progress-bar-green" style="width: 40%" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">
                          <span class="sr-only">40% Complete</span>
                        </div>
                      </div>
                    </a>
                  </li>
                  <!-- end task item -->
                  <li><!-- Task item -->
                    <a href="#">
                      <h3>
                        Some task I need to do
                        <small class="pull-right">60%</small>
                      </h3>
                      <div class="progress xs">
                        <div class="progress-bar progress-bar-red" style="width: 60%" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">
                          <span class="sr-only">60% Complete</span>
                        </div>
                      </div>
                    </a>
                  </li>
                  <!-- end task item -->
                  <li><!-- Task item -->
                    <a href="#">
                      <h3>
                        Make beautiful transitions
                        <small class="pull-right">80%</small>
                      </h3>
                      <div class="progress xs">
                        <div class="progress-bar progress-bar-yellow" style="width: 80%" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">
                          <span class="sr-only">80% Complete</span>
                        </div>
                      </div>
                    </a>
                  </li>
                  <!-- end task item -->
                </ul>
              </li>
              <li class="footer">
                <a href="#">View all tasks</a>
              </li>
            </ul>
          </li>
          <!-- User Account: style can be found in dropdown.less -->
          <li class="dropdown user user-menu">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <!-- <img src="AdminLTE/dist/img/user2-160x160.jpg" class="user-image" alt="User Image"> -->
              <img src="images/person-icon.png" class="user-image" alt="Usuario">
              <span class="hidden-xs">{{this.$auth.user.profile.name}}</span>
            </a>
            <ul class="dropdown-menu">
              <!-- User image -->
              <li class="user-header">
                <!-- <img src="AdminLTE/dist/img/user2-160x160.jpg" class="img-circle" alt="User Image"> -->
                <img src="images/person-icon.png" class="img-circle" alt="Usuario">

                <p>
                  {{this.$auth.user.profile.name}}<!--  - Web Developer -->
                  <!-- <small>Member since Nov. 2012</small> -->
                </p>
              </li>
              <!-- Menu Body -->
<!--               <li class="user-body">
                <div class="row">
                  <div class="col-xs-4 text-center">
                    <a href="#">Followers</a>
                  </div>
                  <div class="col-xs-4 text-center">
                    <a href="#">Sales</a>
                  </div>
                  <div class="col-xs-4 text-center">
                    <a href="#">Friends</a>
                  </div>
                </div>
              </li>
 -->
              <!-- Menu Footer-->
              <li class="user-footer">
<!--
                <div class="pull-left">
                  <a href="#" class="btn btn-default btn-flat">Profile</a>
                </div>
 -->
                <div class="pull-left">
                  <a class="btn btn-default btn-flat" @click="handleChangePassword">Cambiar Contraseña</a>
                </div>

                 <div class="pull-right">
                  <a class="btn btn-default btn-flat" @click="logout">Salir</a>
                </div>
              </li>
            </ul>
          </li>
          <!-- Control Sidebar Toggle Button -->
          <li v-if="false">
            <a href="#" data-toggle="control-sidebar"><i class="fa fa-gears"></i></a>
          </li>
        </ul>
      </div>
    </nav>
  </header>
  <el-dialog title="Cambiar Contraseña" :visible.sync="dialogFormVisible">
			<el-form :model="resource" label-position="right" :rules="changePasswordRules" ref="changePasswordForm">
        <el-form-item label="Contraseña" label-width="240px" prop="password" :error="errors.password">
            <el-input type="password" v-model="resource.password" auto-complete="off" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="Confirmación de Contraseña" label-width="240px" prop="passwordConfirm" :error="errors.passwordConfirm">
            <el-input type="password" v-model="resource.passwordConfirm" auto-complete="off" size="mini"></el-input>
        </el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">Cancelar</el-button>
				<el-button type="primary" @click="handleChangePasswordSubmit">Confirmar</el-button>
			</span>
	</el-dialog>
  </div>
</template>

<style>
.navbar-title {
  color: #ecf0f5;
  display: inline;
  margin-left: 50px;
  font-size: 28px;
  line-height: unset;
}
.img-circle,
.user-image {
  background-color: #fff;
}
</style>

<script>
    export default {
        props: [
          'title',
        ],
        data() {
          var validatePass = (rule, value, callback) => {
            if (value.trim() === '') {
              callback(new Error('Campo requerido'));
            } else {
              if (this.resource.passwordConfirm !== '') {
                this.$refs.changePasswordForm.validateField('passwordConfirm');
              }
              callback();
            }
          };
          var validatePassConfirm = (rule, value, callback) => {
            if (value.trim() === '') {
              callback(new Error('Campo requerido'));
            } else if (value !== this.resource.password) {
              callback(new Error('El valor debe ser igual al de la contraseña'));
            } else {
              callback();
            }
          };
            return {
                errors: {},
                dialogFormVisible: false,
                resource: {
                    password: null,
                    passwordConfirm: null,
                },
                changePasswordRules: {
                  password: [
                    { validator: validatePass, trigger: 'blur' }
                  ],
                  passwordConfirm: [
                    { validator: validatePassConfirm, trigger: 'blur' }
                  ],
                }
            }
        },
        methods: {
            logout() {
               this.$auth.signout(this);
            },
            handleChangePassword() {
              this.resource.password = null;
              this.resource.passwordConfirm = null;
              this.errors = {};
              this.dialogFormVisible = true;
            },
            handleChangePasswordSubmit() {
              axios.patch('/api/users/changepassword', this.resource)
                .then((response) => {
                  // console.log(response);
                  this.resource.password = null;
                  this.resource.passwordConfirm = null;
                  this.errors = {};
                  this.dialogFormVisible = false;
                })
                .catch((error) => {
                  console.log(error.response);
                  if (error.response.status == 422) {
                    _.each(error.response.data.errors, (value, key) => {
                      this.errors[key] = value.join(', ');
                      this.$refs.changePasswordForm.validateField(key);
                    });
                  }
                });
            }
        }
    }
</script>